import React, { FC } from 'react';

import { Container, Layer, Title, ButtonsWrapper } from './styles';

interface ConfirmModalProps {
  title: string;
  handleOnAccept: (id?: number) => void | Promise<void>;
  handleOnReject: () => void;
}

const ConfirmModal: FC<ConfirmModalProps> = ({
  title,
  handleOnReject,
  handleOnAccept,
}) => {
  return (
    <Layer>
      <Container>
        <Title>{title}</Title>
        <ButtonsWrapper>
          <button
            type="button"
            className="button-reject"
            onClick={handleOnReject}
          >
            Não
          </button>
          <button
            type="button"
            className="button-accept"
            onClick={() => handleOnAccept()}
          >
            Sim
          </button>
        </ButtonsWrapper>
      </Container>
    </Layer>
  );
};

export default ConfirmModal;
